export enum DEVICE_TYPE {
    Pc = "pc",
    Mobile = "mobile",
    PcLow = "pc_low"
}